(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filtro-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('filtro-landing')) {
    customElements.define('filtro-landing', class extends HTMLElement {
      connectedCallback() {
        this.handleClick = (event) => {
          const thumb = event.target.closest('[data-fl-thumb]');
          if (thumb && this.contains(thumb)) this.showImage(thumb.dataset.flThumb);
        };
        this.handleChange = (event) => {
          if (!event.target.matches('[data-fl-variant]')) return;
          const option = event.target.selectedOptions[0];
          if (!option) return;
          const price = this.querySelector('[data-fl-price]');
          const compare = this.querySelector('[data-fl-compare]');
          const submit = this.querySelector('[data-fl-submit]');
          const quantity = this.querySelector('[data-fl-quantity]');
          if (price) price.textContent = option.dataset.price;
          if (compare) { compare.textContent = option.dataset.compare; compare.hidden = option.dataset.sale !== 'true'; }
          if (submit) { submit.disabled = option.dataset.available !== 'true'; submit.textContent = submit.disabled ? submit.dataset.sold : submit.dataset.label; }
          if (quantity) {
            quantity.min = option.dataset.min || '1';
            quantity.step = option.dataset.step || '1';
            if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
            quantity.value = quantity.min;
          }
          this.showImage(option.dataset.image);
        };
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleChange);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleChange);
      }
      showImage(id) {
        const slides = Array.from(this.querySelectorAll('[data-fl-slide]'));
        if (!id || !slides.some(slide => slide.dataset.flSlide === id)) return;
        slides.forEach(slide => { slide.hidden = slide.dataset.flSlide !== id; });
        this.querySelectorAll('[data-fl-thumb]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.flThumb === id)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
